<template>
  <div class="industry-dashboard-container full-width full-height">
    <!-- Cabeçalho -->
    <div class="row q-pa-md">
      <div class="col-12">
        <h5 class="q-ma-none q-mb-md"><translate>INDUSTRY_DASHBOARD</translate></h5>
      </div>
    </div>

    <!-- iframe com o BI externo -->
    <div class="row q-px-md">
      <div class="col-12">
        <q-card class="bi-card">
          <q-card-section class="q-pa-none">
            <iframe
              :src="biUrl"
              class="bi-iframe"
              title="Dashboard da Indústria"
              @load="onIframeLoad"
            >
              <p><translate>BROWSER_NO_IFRAME_SUPPORT</translate></p>
            </iframe>
          </q-card-section>
        </q-card>
      </div>
    </div>

    <!-- Loading indicator -->
    <q-inner-loading :showing="isLoading">
      <q-spinner-gears size="50px" color="primary" />
      <div class="q-mt-md"><translate>LOADING_DASHBOARD</translate></div>
    </q-inner-loading>
  </div>
</template>

<script>
import { Component, Vue } from 'vue-property-decorator'

@Component({
  name: 'IndustryDashboard',
  props: {
    id: String,
    interface: String,
    name: String
  }
})
export default class IndustryDashboard extends Vue {
  biUrl = ''
  isLoading = true

  onIframeLoad () {
    this.isLoading = false
  }

  async mounted () {
    await this.loadDashboardUrl()
  }

  async loadDashboardUrl () {
    try {
      this.isLoading = true

      const response = await this.$http.get('/industry-dashboard/qlik-url')

      if (response && response.data) {
        this.biUrl = response.data
      } else {
        throw new Error('Resposta inválida do servidor')
      }
    } catch (error) {
      this.isLoading = false
      console.error('Erro ao carregar dashboard:', error)
      this.$q.notify({
        type: 'negative',
        message: this.$gettext('ERROR_LOADING_BI_DASHBOARD')
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.industry-dashboard-container {
  background-color: #f5f5f5;
}

.bi-card {
  min-height: calc(100vh - 150px);
  height: calc(100vh - 150px);
}

.bi-iframe {
  width: 100%;
  height: calc(100vh - 150px);
  min-height: 800px;
  border: none;
}

h5 {
  font-size: 1.5rem;
  font-weight: 500;
  color: #333;
}
</style>
